export const LANGS = [
  { code: 'pt-br', label: 'Brasil', sub: 'Português – pt-BR', short: 'BR', htmlLang: 'pt-BR' },
  { code: 'es', label: 'LATAM', sub: 'Español – Latinoamérica', short: 'LATAM', htmlLang: 'es' },
];

export const LANG_CODES = ['pt-br', 'es'];

export const ROUTE_SLUGS = {
  'pt-br': { home: '', solutions: 'solucoes', products: 'produtos', about: 'sobre', contact: 'contato', passengers: 'monitriip-e-dashcam', faq: 'faq', privacy: 'privacidade', terms: 'termos' },
  es: { home: '', solutions: 'soluciones', products: 'productos', about: 'sobre', contact: 'contacto', passengers: 'buses-y-dashcam', faq: 'preguntas-frecuentes', privacy: 'privacidad', terms: 'terminos' },
};

export const routePath = (lang, key) => {
  const slug = (ROUTE_SLUGS[lang] || {})[key];
  return `/${lang}${slug ? '/' + slug : ''}`;
};

export const findRouteKey = (lang, sub) => {
  const slugs = ROUTE_SLUGS[lang] || {};
  return Object.keys(slugs).find((k) => slugs[k] === sub) || null;
};